<template>
    <div :class="containerClass" @click="onWrapperClick">
        <template v-if="auth.isLoggedIn">
            <header class="relative z-50 w-full card p-0 bg-blue-50">
                <div
                    class="flex flex-grow-1 justify-center h-full py-5 max-w-6xl px-2 mx-auto sm:justify-content-between xl:px-0">
                    <div class="">
                        <router-link to="/">
                          <Button class=" flex justify-center align-content-center p-button-link p-0 font-black text-left text-black">
                                <img src="images/logo_white.png" alt="logo"
                                    style="width: 80px; border-radius: 50%;" class="" />
                                <span class=" flex align-items-center justify-content-center text-2xl text-black ml-2"> Community Water and Sanitation Agency  <br> (CWSA)</span>
                            </Button>
                        </router-link>
                    </div>
                    <div class="mt-2 hidden-sm hidden-xs text-right">
                        <div class="text-md font-bold text-primary">Welcome back, {{ auth.user.name }}</div>
                        <div class="text-md text-gray-500"> {{ auth.userTelephone }} </div>
                        <div class="">
                            <Button @click="startLogout()" class=" font-bold p-button-danger p-button-text p-0"
                                label="Sign Out" icon="pi pi-power-off"></Button>
                        </div>
                    </div>
                </div>
            </header>
        </template>
        <template v-else>
            <header class="relative z-50 w-full card p-0 bg-blue-50">
                <div
                    class="flex flex-grow-1 justify-center align-content-center h-full py-5 max-w-6xl px-2 mx-auto sm:justify-content-between xl:px-0">
                    <div class="">
                        <router-link to="/">
                            <Button class=" flex justify-center align-content-center p-button-link p-0 font-black text-left text-black">
                                <img src="images/logo_white.png" alt="logo"
                                    style="width: 80px; border-radius: 50%; " class="" />
                                <span class=" flex align-items-center justify-content-center text-2xl text-black ml-2"> Community Water and Sanitation Agency  <br> (CWSA)</span>
                            </Button>
                        </router-link>
                    </div>
                </div>
            </header>
        </template>

        <div class="layout-main-container max-w-6xl mx-auto xl:px-0">
            <div class="layout-main">
                <router-view />
            </div>
        </div>

        <footer class="pt-12 pb-5 text-white bg-white border-t border-gray-200">
            <div class="container flex flex-col justify-between max-w-6xl px-4 mx-auto overflow-hidden lg:flex-row">
                <div class="w-full pl-5 mr-4 text-left lg:w-1/4 sm:text-center sm:pl-0 lg:text-left">
                    <img src="images/logo_white.png" alt="logo" style="width: 50px; border-radius: 50%; overflow: hidden"
                        class="" />
                    <p class="mr-4 mt-3 text-xs text-gray-500">
                        Copyright 2023 {{ $appName }}. All Rights Reserved. <br> Powered by
                        <a target="_blank" href="https://afrifanom.com">Afrifanom Limited</a>
                    </p>
                </div>
                <div class="block w-full pl-10 mt-6 text-sm lg:w-3/4 sm:flex lg:mt-0">
                    <ul class="flex flex-col w-full p-0 font-medium text-left text-gray-700 list-none">
                        <li>
                            <a :href="$apiUrl + `info/faq`" target="_blank"
                                class="inline-block py-2 text-gray-500 no-underline hover:text-gray-600">
                                FAQs</a>
                        </li>
                        <li>
                            <a :href="$apiUrl + `info/privacypolicy`" target="_blank"
                                class="inline-block py-2 text-gray-500 no-underline hover:text-gray-600">
                                Privacy Policy</a>
                        </li>
                        <li>
                            <a :href="$apiUrl + `info/termsofuse`" target="_blank"
                                class="inline-block py-2 text-gray-500 no-underline hover:text-gray-600">
                                Terms of Use</a>
                        </li>
                    </ul>
                    <div class="flex flex-col w-full text-gray-700">
                        <div class="inline-block py-2 mt-5 font-bold text-gray-800 uppercase md:mt-0">
                            Contact Us
                        </div>
                        <ul class="flex flex-col w-full p-0 font-medium text-left text-gray-700 list-none">
                            <li>
                                Tel: +233-30-2983104 (Toll-free on vodafone)
                            </li>
                            <li class="mt-2">
                                Email: info@cwsa.gov.gh
                            </li>
                            <li class="mt-2">
                                Website: www.cwsa.gov.gh
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>


        <!-- App right drawer -->
        <Sidebar :showCloseIcon="false" position="right" v-model:visible="rightDrawer.showDrawer"
            :style="{ width: rightDrawer.width }">
            <component v-if="rightDrawer.showDrawer" is-sub-page :is="drawerComponentFile" :api-path="rightDrawer.pageUrl"
                :page-data="rightDrawer.pageData" />
        </Sidebar>

        <transition name="layout-mask">
            <div class="layout-mask p-component-overlay" v-if="mobileMenuActive"></div>
        </transition>

        <!-- Page display dialog -->
        <Dialog class="card py-4 px-0" :breakpoints="{ '960px': '50vw', '640px': '95vw' }"
            :style="{ width: pageDialog.width, maxWidth: pageDialog.maxWidth }" :modal="!pageDialog.seamless"
            :maximized="pageDialog.maximized" :dismissableMask="!pageDialog.persistent" :position="pageDialog.position"
            v-model:visible="pageDialog.showDialog" :showHeader="false">
            <Button v-if="pageDialog.closeBtn" @click="pageDialog.showDialog = false"
                style="position:absolute;right:0px;top:0px" icon="pi pi-times"
                class="p-button-rounded p-button-text p-button-plain" />

            <component v-if="pageDialog.showDialog" is-sub-page :is="dialogComponentFile" :api-path="pageDialog.pageUrl"
                :page-data="pageDialog.pageData" />
        </Dialog>

        <!-- image preview dialog-->
        <Dialog class="card p-0" header="..." :showHeader="true" :breakpoints="{ '960px': '40vw', '640px': '95vw' }"
            style="width:auto" v-model:visible="imageDialog.showDialog" dismissableMask modal>
            <div class="text-center">
                <Carousel v-if="imageDialog.images.length > 1" :value="imageDialog.images" :circular="false"
                    :page="imageDialog.currentSlide">
                    <template #item="{ data }">
                        <div class="text-center">
                            <NiceImage style="max-width:100%;max-height:70vh" :src="data" />
                        </div>
                    </template>
                </Carousel>
                <NiceImage v-else style="max-width:100%;max-height:70vh" :src="imageDialog.images[0]" />
            </div>
        </Dialog>

        <!-- request error dialog -->
        <!-- <Dialog class="card p-0" modal v-model:visible="errorDialog" :breakpoints="{ '960px': '50vw', '640px': '95vw' }"
            style="width:30vw;" position="top">
            <template #header>
                <div class="flex align-items-center">
                    <div class="text-grey-500 font-bold text-lg text-pink-600" v-for="(msg, index) in pageErrors"
                        :key="index">
                        {{ msg }}
                    </div>
                </div>
            </template>
        </Dialog> -->

        <!-- app confirm page dialog -->
        <ConfirmDialog></ConfirmDialog>

        <!-- app flash message toast -->
        <Toast position="top-center" />

        <!-- app fullscreen loading dialog -->
        <Dialog class="card m-0" :showHeader="false" modal v-model:visible="fullScreenLoading"
            :breakpoints="{ '960px': '50vw', '640px': '95vw' }" style="width:20vw;" position="center">
            <ProgressBar mode="indeterminate" style="height: 6px"></ProgressBar>
            <div class="mt-2 text-center text-500">{{ fullScreenLoadingMsg }}</div>
        </Dialog>
    </div>
</template>
<script setup>
import { defineAsyncComponent, ref, toRefs, computed } from "vue";
import { useApp } from 'src/composables/app';
import { useAuth } from 'src/composables/auth';
import { useRoute, useRouter } from 'vue-router';
import { useAppStore } from 'src/store/app';

const app = useApp();
const auth = useAuth();
const store = useAppStore();
//const route = useRoute();
//const router = useRouter();

const { pageDialog, imageDialog, rightDrawer, pageErrors, fullScreenLoading, fullScreenLoadingMsg } = toRefs(store);
const dialogComponentFile = computed(() => {
    if (pageDialog.value.showDialog && pageDialog.value.pageComponent) {
        return defineAsyncComponent(() => import(`src/pages/${pageDialog.value.pageComponent}.vue`));
    }
    return null;
});

const drawerComponentFile = computed(() => {
    if (rightDrawer.value.showDrawer && rightDrawer.value.pageComponent) {
        return defineAsyncComponent(() => import(`src/pages/${rightDrawer.value.pageComponent}.vue`));
    }
    return null;
});

const errorDialog = computed({
    get() {
        return pageErrors.value.length > 0;
    },
    set(newValue) {
        pageErrors.value = [];
    }
});
const layoutMode = ref('static');
const menuClick = ref(false);
const staticMenuInactive = ref(false);
const overlayMenuActive = ref(false);
const mobileMenuActive = ref(false);

const containerClass = computed(() => {
    if (!auth.isLoggedIn) {
        staticMenuInactive.value = true;
        mobileMenuActive.value = false;
    }

    return ['layout-wrapper', {
        'layout-overlay': layoutMode.value === 'overlay',
        'layout-static': layoutMode.value === 'static',
        'layout-static-sidebar-inactive': staticMenuInactive.value && layoutMode.value === 'static',
        'layout-overlay-sidebar-active': overlayMenuActive.value && layoutMode.value === 'overlay',
        'layout-mobile-sidebar-active': mobileMenuActive.value,
        'p-input-filled': false,
    }];
});

function onMenuItemClick(event) {
    if (event.item && !event.item.items) {
        overlayMenuActive.value = false;
        mobileMenuActive.value = false;
    }
}

function onWrapperClick() {
    if (!menuClick.value) {
        overlayMenuActive.value = false;
        mobileMenuActive.value = false;
    }
    menuClick.value = false;
}

function onMenuToggle() {
    menuClick.value = true;
    if (app.isDesktop()) {
        if (layoutMode.value === 'overlay') {
            if (mobileMenuActive.value === true) {
                overlayMenuActive.value = true;
            }
            overlayMenuActive.value = !overlayMenuActive.value;
            mobileMenuActive.value = false;
        }
        else if (layoutMode.value === 'static') {
            staticMenuInactive.value = !staticMenuInactive.value;
        }
    }
    else {
        mobileMenuActive.value = !mobileMenuActive.value;
    }
}
const appBarActionMenu = [
    {
        to: '/account',
        label: "My Account",
        icon: 'pi pi-user',
    },
    {
        label: "Logout",
        icon: 'pi pi-window-minimize',
        command: (event) => {
            startLogout();
        },
    },
];
function startLogout() {
    auth.logout();
    location.href = "/"; //reload page and navigated to index page
}

</script>